import { Card, Col, Row, Spin, Select, notification } from 'antd';
import React, { useEffect, useRef, useState } from 'react';

import * as Api from 'api';
import SharedCamerasItem from 'components/share/SharedCamerasItem';
import ShareCameraMap from 'components/share/shareCameraMap';
import ProfileNotificationChecklist from 'components/profile/profileNotificationChecklist';
import useAuth from 'redux/auth/auth.hook';
import classes from './style.module.scss';

const SharedCameraPage = () => {
  const { auth: { profile } } = useAuth();
  const [selectedCameras, setSelectedCameras] = useState<any[]>([]);
  const [sharedAccounts, setSharedAccounts] = useState<any[]>([]);
  const leftMap = useRef<any>();
  const [loading, setLoading] = useState(false);
  const [sharedCamera, setSharedCamera] = useState<any>(null);
  const [sharedCameras, setSharedCameras] = useState<any[]>([]);
  const [checkedPush, setCheckedPush] = React.useState([false, false, false, false, false, false, false, false]);

  const onChangePushCategory = (checkedValues) => {
    const params = {
      id: sharedCamera.shared_id,
      push_deer: checkedValues.deer,
      push_hog: checkedValues.hog,
      push_turkey: checkedValues.turkey,
      push_vehicle: checkedValues.vehicle,
      push_people: checkedValues.people,
      push_predator: checkedValues.predator,
      push_other: checkedValues.other,
    };
    const updatedSharedCamera = { ...sharedCamera };
    updatedSharedCamera.push_notification = {
      push_deer: checkedValues.deer,
      push_hog: checkedValues.hog,
      push_turkey: checkedValues.turkey,
      push_vehicle: checkedValues.vehicle,
      push_people: checkedValues.people,
      push_predator: checkedValues.predator,
      push_other: checkedValues.other,
    };
    setSharedCamera(updatedSharedCamera);
    Api.SHARED_REPORT_PUSH_CATEGORIES(params).then(((res: any) => {
      const updatedSharedCameras = sharedCameras.map((cam) => {
        if (cam.shared_id === sharedCamera.shared_id) {
          return updatedSharedCamera;
        }
        return cam;
      });

      setSharedCameras(updatedSharedCameras);
      notification.open({
        message: res.text,
      });
    }));
  };

  const initValues = (data) => {
    const newPushCategories: boolean[] = [];
    if (data.push_deer == '1') {
      newPushCategories.push(true);
      newPushCategories.push(true);
    } else if (data.push_deer == '2') {
      newPushCategories.push(true);
      newPushCategories.push(false);
    } else if (data.push_deer == '3') {
      newPushCategories.push(false);
      newPushCategories.push(true);
    } else {
      newPushCategories.push(false);
      newPushCategories.push(false);
    }

    newPushCategories.push(data.push_hog == '1');
    newPushCategories.push(data.push_turkey == '1');
    newPushCategories.push(data.push_people == '1');
    newPushCategories.push(data.push_vehicle == '1');
    newPushCategories.push(data.push_predator == '1');
    newPushCategories.push(data.push_other == '1');
    setCheckedPush(newPushCategories);
  };

  useEffect(() => {
    if (profile) {
      getSharedAccounts();
    }
  }, [profile]);

  useEffect(() => {
    if (sharedCamera) {
      initValues(sharedCamera.push_notification);
    }
  }, [sharedCamera]);

  const getSharedAccounts = () => {
    setLoading(true);
    Api.SHRAED_CAMERA().then(((res: any) => {
      const accounts = JSON.parse(res.text);
      setSharedAccounts(accounts);
      const cameras: any[] = [];
      if (accounts.length > 0) {
        setSelectedCameras(accounts[0].cameras);
        for (let i = 0; i < accounts.length; i += 1) {
          if (accounts[i].cameras.length > 0) {
            for (let j = 0; j < accounts[i].cameras.length; j += 1) {
              cameras.push(accounts[i].cameras[j]);
            }
          }
        }
        setSharedCameras(cameras);
        setSharedCamera(cameras[0]);
        initValues(cameras[0].push_notification);
      }
      setLoading(false);
    })).catch((error: any) => {
      console.log('error ===>', error);
    });
  };

  const onclickInnerCard = (cameras) => {
    setSelectedCameras(cameras);
  };

  return (
    <>
      <Spin spinning={loading} size="large">
        <Row>
          <Col md={12} xs={24} className={classes.leftMap}>
            <ShareCameraMap cameras={selectedCameras} ref={leftMap} />
          </Col>
          <Col md={12} xs={24} className={classes.sharedAccount}>
            <Card title="Shared Camera by Others">
              {
                sharedAccounts.map((account, i) => (
                  <SharedCamerasItem key={i} account={account} onClick={onclickInnerCard} />
                ))
              }
            </Card>
          </Col>
          <Col md={12} xs={24} className={classes.sharedAccount}>
            <Card title="Push Notification Setting for Shared Cameras">
              <Row>
                <Col xs={24} md={12}>
                  <p>Please select the camera: </p>
                  <Select
                    size="large"
                    className={classes.select}
                    onChange={(id: string) => {
                      const camera = sharedCameras.find((c) => c.id === id) || null;
                      setSharedCamera(camera);
                    }}
                    value={sharedCamera?.id}
                  >
                    {sharedCameras.map((camera) => (
                      <Select.Option key={camera.id} value={camera.id}>
                        {camera.name}
                      </Select.Option>
                    ))}
                  </Select>
                </Col>
                <Col xs={24} md={12}>
                  <ProfileNotificationChecklist title="Push (Mobile Apps)" values={checkedPush} onChange={onChangePushCategory} />
                </Col>
              </Row>
            </Card>
          </Col>
        </Row>
      </Spin>
    </>
  );
};

export default SharedCameraPage;
